import angular from 'angular';
import loansSummary from './loansSummary';
import './style.scss';

export default angular
  .module('components.loansSummary', [])
  .component('loansSummary', loansSummary).name;
